/* eslint-disable no-undef */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Rendra Pramulia
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View } from 'react-native';
import * as Yup from 'yup';

import ModalFull from '@components/modal/ModalFull';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import SociollaText from '@components/sociolla/SociollaText';
import {
  SociollaForm,
  SociollaInput,
  SociollaSelectProduct,
  SociollaSubmitButton,
} from '@components/sociolla/form';

const validationSchema = Yup.object().shape({
  products: Yup.object().required('Product is required').label('Product'),
  sales_price: Yup.number()
    .required('Sales Price is required')
    .typeError('Sales Price should number only')
    .min(1, 'Please add minimum 1')
    .label('Sales Price'),
  vat: Yup.number()
    .required('VAT is required')
    .typeError('VAT should number only')
    .min(0, 'Please add minimum 0')
    .label('VAT'),
});

const ModalProduct = (props) => {
  const dispatch = useDispatch();
  const productPriceRules = useSelector(
    (state) => state.modal.productPriceRules,
  );

  const onClose = () => {
    dispatch(showPopup({ name: 'productPriceRules', value: false }));
  };

  const isProductValid = (prod) => {
    let isValid = true;
    let msg = '';
    if (!prod.products?.category?.id) {
      msg = `Product doesn't have category`;
      isValid = false;
    }

    if (!isValid) {
      dispatch(
        showAlert({
          show: true,
          title: 'Invalid Product',
          description: msg,
          isConfirm: false,
        }),
      );
    }

    return isValid;
  };

  const handleSubmit = async (data, { resetForm }) => {
    if (!isProductValid(data)) {
      return;
    }

    props.onSubmit(
      data,
      props.product ? props.product.index : -1,
      props.product?.item || null,
    );
    resetForm();
    onClose();
  };

  return (
    <>
      {productPriceRules && (
        <ModalFull
          show={productPriceRules}
          title={props.product ? 'Edit Product' : 'Add Product'}
          width={isWeb ? 406 : '100%'}
          onClose={() => onClose()}>
          <View style={{ padding: 15 }}>
            <SociollaForm
              initialValues={{
                products: props.product?.item || '',
                sales_price: props.product?.item?.sales_price || '',
                vat: props.product?.item?.vat || '',
              }}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}>
              <View style={{ marginBottom: 15 }}>
                <SociollaSelectProduct
                  placeholder="Select Product"
                  label="Product"
                  name="products"
                  onSelected={(val) => onSelected(val)}
                  trackBy="name"
                  labelKey="name"
                  editable={Boolean(!props.product)}
                  isRequired
                />
              </View>
              <View style={{ marginBottom: 15 }}>
                <SociollaInput
                  label="Sales Price"
                  name="sales_price"
                  keyboardType="numeric"
                  isRequired
                  isNumeric
                />
              </View>
              <SociollaInput
                label="VAT"
                name="vat"
                keyboardType="numeric"
                isRequired
                isNumeric
              />
              <SociollaSubmitButton
                buttonStyle={{ width: '100%', marginTop: 30 }}
                title={
                  <SociollaText type="medium" style={{ color: Colors.white }}>
                    Save
                  </SociollaText>
                }
              />
            </SociollaForm>
          </View>
        </ModalFull>
      )}
    </>
  );
};

export default ModalProduct;
